// extracted by mini-css-extract-plugin
module.exports = {"btnCode":"SmsCodeButton_btnCode__1F1R4"};